import React from 'react';
import { Col, Form, FormGroup, FormControl, ControlLabel, HelpBlock, Button, Checkbox } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import Scroll from 'react-scroll';
import rest from 'rest';

import { REST_API_URL, APP_PATH, PERMISSION_READ, PERMISSION_CREATE } from "../../Utils/Global";
import { getDateFromString, getIsoStringFromDate, getStringFromDate } from "../../Utils/Date";
import { cloneObject } from "../../Utils/Utils";

import PermissionCheck from '../Permissions/PermissionCheck';

import Grid from '../Helper/Grid';
import Status from '../Helper/Status';

import AbstractEntity from './AbstractEntity';
import Alerte from './Alerte';
import Document from './Document';

/**
* Class EtatDesLieux
* EtatDesLieux view component
**/
class EtatDesLieux extends AbstractEntity {
  /**
  * props
  * mode : readonly/add/edit
  * path : rest api path for the object's type
  * objectPath : rest api path for the object
  * data.object : instance data
  **/

  /**
  * getClassName
  * Returns the class name as String (once bundled the class name changes)
  **/
  static getClassName() {
    return "EtatDesLieux";
  }

  componentDidMount() {
    Scroll.animateScroll.scrollToTop({
      duration: 0,
      delay: 0,
      smooth: true
    });
  }

  /**
  * render
  * Rendering component function : display the view
  **/
  render() {

    if(this.state.object === undefined) {
        return null;
    }

    // Form status information
    const status = <Status parent={this} type={this.state.status.type} message={this.state.status.message} />;

    // Transforms date fields
    let dateEntree = null, dateSortie = null;

    if(this.state.object !== undefined) {
      if(this.state.object.dateEntree) {

        dateEntree = this.state.object.dateEntree;

        if(typeof dateEntree === "string") {
          dateEntree = getDateFromString(dateEntree);
        }

        dateEntree = getIsoStringFromDate(dateEntree);
      }

      if(this.state.object.dateSortie) {

        dateSortie = this.state.object.dateSortie;

        if(typeof dateSortie === "string") {
          dateSortie = getDateFromString(dateSortie);
        }

        dateSortie = getIsoStringFromDate(dateSortie);
      }
    }

    const historyBack = <Button bsStyle="link" onClick={this.props.modal ? this.props.closeModal : this.goBack} className="btnBack"><span className="glyphicon glyphicon-arrow-left" /> Retour</Button>;

    // Rendering the view
		return (
      <div>
        {/* Status information */}
        {status}
        {historyBack}
  			<Form ref="etatDesLieuxForm" horizontal onSubmit={this.handleSubmit}>
          <HelpBlock>Formulaire de l'état des lieux.</HelpBlock>

          {/* Form content */}
          <FormGroup controlId="idEtatDesLieux" className="customHidden">
            <Col componentClass={ControlLabel} sm={2}>Identifiant</Col>
            <Col sm={1}><FormControl type="text" value={this.getObjectProperty("idEtatDesLieux")} disabled="true" /></Col>
          </FormGroup>

          <h4 className="edlTitle">Etat des lieux d'entrée</h4>
          <FormGroup controlId="dateEntree">
            <Col componentClass={ControlLabel} sm={2}>Date d'entrée</Col>
            <Col sm={2}><DatePicker dateFormat="DD/MM/YYYY" value={dateEntree} onChange={this.handleDateEntreeChange.bind(this)} disabled={this.getReadOnly()} /></Col>

            {this.state.mode !== "add" && this.getObjectProperty("dateEntree") &&
              <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_CREATE}>
                <Col sm={2}>
                  <Button bsStyle="primary" onClick={this.createEntreeAlerte.bind(this)}>Générer une alerte d'entrée</Button>
                </Col>
              </PermissionCheck>
            }
          </FormGroup>

          <FormGroup controlId="cleRemiseEntree">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel></ControlLabel></Col>
            <Col sm={2}><Checkbox name="cleRemiseEntree" onChange={this.handleCheckboxChange.bind(this)} checked={this.getObjectProperty("cleRemiseEntree")}
              disabled={this.getReadOnly()}>clés remises en entrée</Checkbox></Col>
          </FormGroup>

          <FormGroup controlId="caution">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel></ControlLabel></Col>
            <Col sm={2}><Checkbox name="caution" onChange={this.handleCheckboxChange.bind(this)} checked={this.getObjectProperty("caution")}
              disabled={this.getReadOnly()}>caution</Checkbox></Col>
          </FormGroup>

          <FormGroup controlId="personneChargeEntree">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Personne en charge</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("personneChargeEntree")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="personneRencontreeEntree">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Personne rencontrée</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("personneRencontreeEntree")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaireEntree">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaireEntree")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <h4 className="edlTitle">Etat des lieux de sortie</h4>
          <FormGroup controlId="dateSortie">
            <Col componentClass={ControlLabel} sm={2}>Date de sortie</Col>
            <Col sm={2}><DatePicker minDate={dateEntree} dateFormat="DD/MM/YYYY" value={dateSortie} onChange={this.handleDateSortieChange.bind(this)} disabled={this.getReadOnly()} /></Col>

            {this.state.mode !== "add" && this.getObjectProperty("dateSortie") &&
              <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_CREATE}>
                <Col sm={2}>
                  <Button bsStyle="primary" onClick={this.createSortieAlerte.bind(this)}>Générer une alerte de sortie</Button>
                </Col>
              </PermissionCheck>
            }
          </FormGroup>

          <FormGroup controlId="cleRemiseSortie">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel></ControlLabel></Col>
            <Col sm={2}><Checkbox name="cleRemiseSortie" onChange={this.handleCheckboxChange.bind(this)} checked={this.getObjectProperty("cleRemiseSortie")}
              disabled={this.getReadOnly()}>clés remises en sortie</Checkbox></Col>
          </FormGroup>

          <FormGroup controlId="prevoirTravaux">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel></ControlLabel></Col>
            <Col sm={2}><Checkbox name="prevoirTravaux" onChange={this.handleCheckboxChange.bind(this)} checked={this.getObjectProperty("prevoirTravaux")}
              disabled={this.getReadOnly()}>travaux à prévoir</Checkbox></Col>
          </FormGroup>

          { this.getObjectProperty("prevoirTravaux") === true &&
            <FormGroup controlId="commentaireTravaux">
              <Col componentClass={ControlLabel} sm={2}><ControlLabel>Travaux</ControlLabel></Col>
              <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaireTravaux")}
                disabled={this.getReadOnly()} /></Col>
            </FormGroup>
          }


          <FormGroup controlId="personneChargeSortie">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Personne en charge</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("personneChargeSortie")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="personneRencontreeSortie">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Personne rencontrée</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl type="text" onChange={this.handleChange} value={this.getObjectProperty("personneRencontreeSortie")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          <FormGroup controlId="commentaireSortie">
            <Col componentClass={ControlLabel} sm={2}><ControlLabel>Commentaire</ControlLabel></Col>
            <Col componentClass={ControlLabel} sm={6}><FormControl onChange={this.handleChange} componentClass="textarea" rows="5" value={this.getObjectProperty("commentaireSortie")}
              disabled={this.getReadOnly()} /></Col>
          </FormGroup>

          {/* Document OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Document.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Documents" path="documents" objectPath={"etatdeslieux/" + this.getObjectProperty("idEtatDesLieux") + "/documents"}
              objectClass={Document} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Alerte OneToMany */}
          {this.state.mode !== "add" &&
            <PermissionCheck component={Alerte.getClassName()} permission={PERMISSION_READ}>
              <Grid title="Alertes" ref="alertesGrid" path="alertes" objectPath={"etatdeslieux/" + this.getObjectProperty("idEtatDesLieux") + "/alertes"}
              objectClass={Alerte} hiddable={true} mode={this.state.mode} />
            </PermissionCheck>
          }

          {/* Submit button */}
          {this.state.mode !== "readonly" &&
            <FormGroup>
              <Col smOffset={7} sm={1}>
                <Button bsStyle="success" onClick={this.submit.bind(this)}>Sauvegarder</Button>
              </Col>
            </FormGroup>
          }
        </Form>
      </div>
		);
	}

  /**
  * getIdField
  * Returns the object idField
  **/
  getIdField() {
    return "idEtatDesLieux";
  }

  /**
  * submit
  * Saves the data
  **/
  submit () {
    let method;
    const path = REST_API_URL + this.getObjectPath();

    if(this.state.mode === "edit") {
      method = "PUT";
    } else if (this.state.mode === "add") {
      method = "POST";
    }

    const etatDesLieuxObj = this.getEtatDesLieux();

    Scroll.animateScroll.scrollToTop({
      duration: 1000,
      delay: 100,
      smooth: true
    });

    rest({
      method: method,
      path: path,
      entity: JSON.stringify(etatDesLieuxObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 200) {
        this.setState({
          status: {
            type: 'success',
            message: 'Etat des lieux sauvegardé.'
          },
          object: JSON.parse(response.entity)
        });
      } else if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity);
        const state = {
          status: {
            type: 'success',
            message: 'Etat des lieux créé.'
          },
          mode: 'edit',
          object: newObj
        };

        this.replaceHistory(APP_PATH + "/etatdeslieux/" + newObj.idEtatDesLieux + "/edit", state);

        if(this.props.onAdd) {
          this.props.onAdd.call(this, newObj);
        }

      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

  /**
  * getEtatDesLieux
  * Returns the EtatDesLieux object
  **/
  getEtatDesLieux() {
    let etatDesLieuxObj = cloneObject(this.state.object);

    if(typeof etatDesLieuxObj.dateEntree !== "string") {
      etatDesLieuxObj.dateEntree = getStringFromDate(etatDesLieuxObj.dateEntree);
    }

    if(typeof etatDesLieuxObj.dateSortie !== "string") {
      etatDesLieuxObj.dateSortie = getStringFromDate(etatDesLieuxObj.dateSortie);
    }

    if(etatDesLieuxObj.cleRemiseEntree === undefined) {
      etatDesLieuxObj.cleRemiseEntree = false;
    }

    if(etatDesLieuxObj.cleRemiseSortie === undefined) {
      etatDesLieuxObj.cleRemiseSortie = false;
    }

    if(etatDesLieuxObj.prevoirTravaux === undefined) {
      etatDesLieuxObj.prevoirTravaux = false;
    }

    if(etatDesLieuxObj.prevoirTravaux !== true) {
      etatDesLieuxObj.commentaireTravaux = null;
    }

    if(etatDesLieuxObj.caution === undefined) {
      etatDesLieuxObj.caution = false;
    }

    return etatDesLieuxObj;
  }

  /**
  * handleDateEntreeChange
  * Modify the state dateEntree property from dateEntree field change
  **/
  handleDateEntreeChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateEntree"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * handleDateSortieChange
  * Modify the state dateSortie property from dateSortie field change
  **/
  handleDateSortieChange(dateString, formattedDate) {
    let objState = this.state;
    objState.object["dateSortie"] = (dateString !== null) ? new Date(dateString) : null;
    this.setState(objState);
  }

  /**
  * createEntreeAlerte
  * Create check-in inventory Alerte
  **/
  createEntreeAlerte() {
    this.createEntreeSortieAlertes("entree");
  }

  /**
  * createSortieAlerte
  * Create check-out inventory Alerte
  **/
  createSortieAlerte() {
    this.createEntreeSortieAlertes("sortie");
  }

  /**
  * createEntreeSortieAlertes
  * Create check-in/out inventory Alerte
  **/
  createEntreeSortieAlertes(type) {
    const path = REST_API_URL + this.getObjectPath() + "/alertes_" + type;
    const etatDesLieuxObj = this.getEtatDesLieux();

    rest({
      method: "PUT",
      path: path,
      entity: JSON.stringify(etatDesLieuxObj),
      headers: {
  			'Content-Type': 'application/json'
  		}
    }).then(response => {
      if(response.status.code === 201) {
        const newObj = JSON.parse(response.entity)[0];

        const state = {
          status: {
            type: 'success',
            message: 'Alerte créée.'
          },
          mode: 'edit',
          object: newObj
        };

        this.pushHistory(APP_PATH + "/alertes/" + newObj.idAlerte + "/edit", state);
      } else {
        this.setState({
          status: {
            type: 'danger',
            message: 'Erreur de sauvegarde.'
          }
        });
      }
  	}, response => {
      this.setState({
        status: {
          type: 'danger',
          message: 'Problème d\'appel au serveur.'
        }
      });
		});
  }

}
export default EtatDesLieux;



// WEBPACK FOOTER //
// ./src/views/Entity/EtatDesLieux.js